// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageEditInfoView from 'xui/modules/storeWebsite/BaseUISalePageEditInfoView'

export default class SalePageEditInfoView extends BaseUISalePageEditInfoView {}
